import { Link, Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { KadryPageHeader } from '../ui';

const Tabs = styled.nav`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TabLink = styled(Link)<{ $active: boolean }>`
  position: relative;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(4)}`};
  font-size: 14px;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  white-space: nowrap;
  color: ${({ $active, theme }) => ($active ? theme.colors.text.primary : theme.colors.text.secondary)};
  text-decoration: none;
  border-radius: ${({ theme }) => `${theme.radius.md} ${theme.radius.md} 0 0`};

  &::after {
    content: '';
    position: absolute;
    left: 16px;
    right: 16px;
    bottom: -1px;
    height: 2px;
    background: ${({ theme }) => theme.colors.primary};
    transform: scaleX(${({ $active }) => ($active ? 1 : 0)});
    transition: transform ${({ theme }) => theme.motion.base} ${({ theme }) => theme.motion.spring};
  }

  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    background: ${({ theme }) => theme.colors.surface};
  }
  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;

const TABS = [
  { path: '/agents/kadry/settings/connections', label: 'Подключения' },
  { path: '/agents/kadry/settings/sites', label: 'Объекты' },
  { path: '/agents/kadry/settings/autooffer', label: 'Предложения' },
  { path: '/agents/kadry/settings/gates', label: 'Функции' },
];

/** Настройки модуля (`hr_admin`): справочник объектов и фичегейты. */
export function SettingsLayout() {
  const { pathname } = useLocation();
  return (
    <>
      <KadryPageHeader
        title="Настройки"
        subtitle="Подключения — hh.ru и Работа.ру, боты Telegram и MAX и готовность к работе. Справочник объектов — места выполнения работ для заявок. Функции — серверные переключатели возможностей модуля; каждое включение фиксируется в журнале."
      />
      <Tabs aria-label="Разделы настроек">
        {TABS.map((t) => {
          const active = pathname.startsWith(t.path);
          return (
            <TabLink key={t.path} to={t.path} $active={active} aria-current={active ? 'page' : undefined}>
              {t.label}
            </TabLink>
          );
        })}
      </Tabs>
      <Outlet />
    </>
  );
}
